import { http } from "../../../config/HttpMethod";
import { fluidViscosityPayload } from "../../../store/model/calculations/calculation";
import { bubblePointPayload, BWPDOutput, CombinedSpGrPayload, FlopPayload, gasCalOutput, gasCalPayload, inflowOutput, ReserPresPayload } from "../../../store/model/calculations/fluid";
import { ESP_ENDPOINTS } from "../endpoints";

export const getWaterCutCombinedSpGr = async (payload: CombinedSpGrPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_WATER_CUT_COMB_SP_GR}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getBWPDvalue = async (payload: object) => {
    try {
        const response = await http.post<BWPDOutput>(`${ESP_ENDPOINTS?.GET_PROD_RATE_CHANGE}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getWateCutOilCut = async (payload: number) => {
    const params = {
        WtrCut: payload
    };
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_WATER_CUT_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getBubblePoint = async (payload: bubblePointPayload) => {
    try {
        const response = await http.post<number>(`${ESP_ENDPOINTS?.GET_BUBBLE_POINT}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getOilAPI = async (payload: number) => {
    const params = {
        GasInpAPI: payload,
    };
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_OIL_API_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getSpGrOil = async (payload: number) => {
    const params = {
        spGraOil: payload,
    };
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_SP_GR_OIL_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getGasCalData = async (payload: gasCalPayload) => {
    try {
        const response = await http.post<gasCalOutput>(`${ESP_ENDPOINTS?.GET_GAS_CALC_DATA}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getFluidViscosityChange = async (payload: fluidViscosityPayload) => {
    try {
        const response = await http.post<number>(`${ESP_ENDPOINTS?.GET_FLUID_VISCOSITY_CHANGE}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
